import { render, staticRenderFns } from "./PartyFaq.vue?vue&type=template&id=d42777fa"
import script from "./PartyFaq.vue?vue&type=script&lang=js"
export * from "./PartyFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports